import { render, staticRenderFns } from "./nationalNum.vue?vue&type=template&id=1d8996e8&scoped=true&"
import script from "./nationalNum.vue?vue&type=script&lang=js&"
export * from "./nationalNum.vue?vue&type=script&lang=js&"
import style0 from "./nationalNum.vue?vue&type=style&index=0&id=1d8996e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8996e8",
  null
  
)

export default component.exports